'use client';
/**
 * @param ident уникальный идентификатор компонента
 * @param name имя элемента
 * @returns xref имя класса
 */ var xref = function(ident) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        args[_key - 1] = arguments[_key];
    }
    return [
        "xref",
        ident,
        args
    ].join("-");
};

export { xref };
